import React from 'react';

import { Button, Divider, Group, Select, useMantineTheme } from '@mantine/core';
import BackButton from 'components/BackButton';
import SimpleHeader from 'layouts/MobileLayout/components/SimpleHeader';
import { useNavigate } from 'react-router-dom';

interface FilterTerms {
  timeRange: 'thirtyDays' | 'ninetyDays' | 'sixMonths' | 'year';
  type: 'attended' | 'all';
}

const AttendancePageHeader = ({
  searchFilters: searchFilters,
  setTimeRange,
  setType,
  showPdfDownloadComponent,
}: {
  searchFilters: FilterTerms;
  setTimeRange: (startDate: 'thirtyDays' | 'ninetyDays' | 'sixMonths' | 'year') => void;
  setType: (type: 'attended' | 'all') => void;
  showPdfDownloadComponent: () => void;
}): JSX.Element => {
  const navigate = useNavigate();

  const handleBackButtonClick = (): void => {
    navigate(-1);
  };
  const theme = useMantineTheme();

  return (
    <>
      <SimpleHeader title='Attendance' />
      <Group
        position='apart'
        p='md'
        w='100%'
        sx={{ borderBottom: '1px solid', borderColor: theme.colors.gray[3] }}
      >
        <BackButton handleOnClick={handleBackButtonClick} />
        <Button color='kiloBlue' component='a' onClick={showPdfDownloadComponent}>
          Send Attendance
        </Button>
      </Group>
      <Divider />
      <Group position='left' p='md' w='100%'>
        <Select
          label='Time Range'
          data-cy='athleteSelect'
          placeholder='Select Time Range'
          value={searchFilters.timeRange}
          onChange={setTimeRange}
          data={[
            { label: 'Last 30 Days', value: 'thirtyDays' },
            { label: 'Last 90 Days', value: 'ninetyDays' },
            { label: 'Last 6 Months', value: 'sixMonths' },
            { label: 'Last Year', value: 'year' },
          ]}
        />

        <Select
          label='Type'
          data-cy='athleteSelect'
          placeholder='Select Type'
          value={searchFilters.type}
          onChange={setType}
          data={[
            { label: 'Only Attended Events', value: 'attended' },
            { label: 'Attended and Unattended Events', value: 'all' },
          ]}
        />
      </Group>
    </>
  );
};

export default AttendancePageHeader;
